/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  ADD_DEAL_SUCCESS,
  ADD_DEAL_FAILURE,

  GET_DEALS_SUCCESS,
  GET_DEALS_FAILURE,

  GET_DEAL_LISTING_SUCCESS,
  GET_DEAL_LISTING_FAILURE,

  TRANSFER_ASSET_SUCCESS,
  TRANSFER_ASSET_FAILURE,
} from '../actions/actionTypes';
const initialState = {
  deals:[],
  userDeals:[],
}
export default function (state = initialState, action) {
  switch (action.type) {
      case ADD_DEAL_SUCCESS:
      return {
        ...state,
          addDealSuccess: true
      }
      case ADD_DEAL_FAILURE:
      return {
        ...state,
        addDealSuccess: false,
        error:action.errResp.message,
      }
      case GET_DEALS_SUCCESS:
        return {
          getDealsSuccess: true,
          deals:action.payload.deals,
      }
      case GET_DEALS_FAILURE:
        return {
          ...state,
          getDealsSuccess: false,
          error:action.errResp.message,
      }

      case GET_DEAL_LISTING_SUCCESS:
        return {
          ...state,
          getUserDealsSuccess: true,
          userDeals: action.payload.deals,
          userDealsError:null,
        }
        case GET_DEAL_LISTING_FAILURE:
          return {
            ...state,
            getUserDealsSuccess: false,
            userDeals: state.userDeals,
            userDealsError: action.errResp.message,
          }
        case TRANSFER_ASSET_SUCCESS:
        return {
          ...state,
          transferAssetSuccess: true,
          transferError:null,
        }
        case TRANSFER_ASSET_FAILURE:
        return {
          ...state,
          transferAssetSuccess: false,
          transferError: 'Unable to perform transfer'
        }

      default:
        return state;
  }
}